import './styles.css';
import { registerSW } from 'virtual:pwa-register';
import { checkDevice, heartbeat, loadPublicConfig } from './api';
import { booking } from './features/booking';
import { chat } from './features/chat';
import { driverGate, requestWakeLock, setupDriverLongPress } from './features/driver';
import { interpreter } from './features/interpreter';
import { language } from './features/language';
import { reviews } from './features/reviews';
import { withAINotice } from './features/notice';
import { initKiosk } from './kiosk';
import { L, config, expireSession, state } from './state';
import { initHome, renderHome } from './ui/home';
import { escapeHtml, initModal, toast } from './ui/modal';

initModal();
initHome();
initKiosk();
setupDriverLongPress();

// Botones invisibles sobre la imagen del dashboard.
const ACTIONS: Record<string, () => void> = {
  chat: () => withAINotice(chat),
  book: booking,
  langs: () => language(),
  reviews,
  interpreter: () => withAINotice(interpreter),
};

for (const button of document.querySelectorAll<HTMLButtonElement>('[data-a]')) {
  button.onclick = () => ACTIONS[button.dataset.a ?? '']?.();
}

setInterval(expireSession, 60_000);
setInterval(() => void heartbeat(), 90_000);

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible' && state.wakeLock === null
      && localStorage.getItem('t2aKeepAwake') === '1') {
    void requestWakeLock();
  }
});

/*
 * Actualización del service worker.
 *
 * El V24 hacía skipWaiting() inmediato, así que una tablet podía recargarse a
 * mitad de un viaje o quedarse con JS viejo y HTML nuevo. Aquí la versión nueva
 * espera: se avisa y sólo se aplica cuando el conductor lo acepta.
 */
const updateSW = registerSW({
  onNeedRefresh() {
    const bar = document.createElement('div');
    bar.className = 'toast';
    bar.innerHTML = escapeHtml(L().app.update) + ' '
      + `<button id="swUpdate" class="mini" type="button" style="margin-left:10px">${escapeHtml(L().app.updateBtn)}</button>`;
    document.body.append(bar);
    bar.querySelector<HTMLButtonElement>('#swUpdate')!.onclick = () => void updateSW(true);
  },
  onOfflineReady() {
    toast(L().app.offlineReady);
  },
});

void (async () => {
  await loadPublicConfig();
  renderHome();

  try {
    if (navigator.onLine) {
      const result = await checkDevice();
      if (result.authorized === false) {
        toast('⚠️ ' + L().form.auth, 8000);
      } else if (result.authorized) {
        if (result.scope?.vehicle_id) config.vehicleId = result.scope.vehicle_id;
        if (result.scope?.tenant_id) config.tenantId = result.scope.tenant_id;
        if (result.scope?.deployment_id) config.deploymentId = result.scope.deployment_id;
        await loadPublicConfig();
        renderHome();
        void heartbeat();
      }
    }
  } catch { /* se sigue en modo sin conexión */ }

  setTimeout(() => language(true), 150);
})();

// Permite abrir el modo conductor desde la consola durante una instalación.
Object.assign(window, { talkxiDriverGate: driverGate });
